import React, { useCallback } from "react";
import { useI18n } from "../i18n/context";
import { SparklesCore } from "./ui/sparkles";
import { BorderMagicButton } from "./ui/border-magic-button";

export default function WelcomeScreen({ onContinue }) {
  const { t } = useI18n();
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onContinue?.();
      }
    },
    [onContinue]
  );

  const openTerms = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    window.dispatchEvent(new CustomEvent('mad:openTerms'));
  }, []);

  const openPrivacy = useCallback((e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    window.dispatchEvent(new CustomEvent('mad:openPrivacy'));
  }, []);

  return (
    <div
      className="relative min-h-[100dvh] min-h-screen w-full max-w-[100vw] min-w-0 overflow-hidden bg-black"
      role="button"
      tabIndex={0}
      onClick={() => onContinue?.()}
      onKeyDown={handleKeyDown}
      aria-label="Open sign in screen"
    >
      {/* Sparkles background */}
      <SparklesCore
        className="absolute inset-0 h-full w-full"
        background="transparent"
        particleColor="#ffffff"
        particleDensity={110}
        minSize={0.6}
        maxSize={1.4}
        speed={1}
      />

      {/* Radial gradient to soften edges + improve contrast */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.05)_0%,rgba(0,0,0,0.75)_70%,rgba(0,0,0,1)_100%)]" />

      {/* Content */}
      <div className="relative z-10 flex min-h-[100dvh] min-h-screen w-full min-w-0 max-w-full flex-col px-4 text-center sm:px-6">
        <div className="flex min-w-0 flex-1 flex-col items-center justify-center">
          <div className="select-none break-words text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            MadCoach
          </div>
          <div className="mt-4 select-none text-sm text-white/70">
            Smart coaching. Mad results
          </div>
        </div>

        <div className="safe-area-inset-bottom pb-8">
          <div className="flex w-full justify-center">
            <BorderMagicButton
              onClick={() => onContinue?.()}
              className="h-14 w-full max-w-sm"
              contentClassName="px-10 text-base font-semibold"
            >
              {t("welcome.cta")}
            </BorderMagicButton>
          </div>
          <div className="mt-4 flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-2">
            <button
              type="button"
              onClick={openTerms}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.stopPropagation();
                  openTerms(e);
                }
              }}
              className="text-xs text-white/50 underline-offset-4 transition-colors hover:text-white/80 hover:underline"
            >
              {t("tos.linkLabel")}
            </button>
            <span className="text-xs text-white/40" aria-hidden>
              ·
            </span>
            <button
              type="button"
              onClick={openPrivacy}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.stopPropagation();
                  openPrivacy(e);
                }
              }}
              className="text-xs text-white/50 underline-offset-4 transition-colors hover:text-white/80 hover:underline"
            >
              {t("privacy.linkLabel")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

